webpackJsonp([94692401586442],{

/***/ 302:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(17);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _styledComponents = __webpack_require__(4);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _polished = __webpack_require__(70);
	
	var _helloColor = __webpack_require__(63);
	
	var _helloColor2 = _interopRequireDefault(_helloColor);
	
	var _colors2 = __webpack_require__(11);
	
	var _colors3 = _interopRequireDefault(_colors2);
	
	var _colors4 = __webpack_require__(56);
	
	var _colors = _interopRequireWildcard(_colors4);
	
	var _mapProps = __webpack_require__(7);
	
	var _mapProps2 = _interopRequireDefault(_mapProps);
	
	var _styleguide = __webpack_require__(14);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _styleguide.ContentRow,
	    null,
	    _react2.default.createElement(
	      _styleguide.Flex,
	      { align: 'center', justify: 'center' },
	      _react2.default.createElement(
	        Form,
	        null,
	        _react2.default.createElement(
	          FormContainer,
	          null,
	          _react2.default.createElement(
	            _styleguide.Paragraph,
	            { weight: 'black', scale: '1', mt: '0', color: _colors3.default.gray[5] },
	            'Sign in'
	          ),
	          _react2.default.createElement(Input, { type: 'text', placeholder: 'email' }),
	          _react2.default.createElement(_styleguide.Fill, { flex: 'fourth', scale: '1' }),
	          _react2.default.createElement(Input, { type: 'secure', placeholder: 'password' }),
	          _react2.default.createElement(_styleguide.Fill, { flex: 'fourth', scale: '1' }),
	          _react2.default.createElement(
	            Button
	            // color={colors.red[6]}
	            ,
	            null,
	            'Sign in'
	          )
	        )
	      )
	    )
	  );
	};
	
	var FormContainer = /*#__PURE__*/(0, _styledComponents2.default)(_styleguide.Fill).attrs({ column: true, flex: 'half', p: 3, px: 'viewport' }).withConfig({
	  displayName: 'signin__FormContainer'
	})(['min-height:20rem;min-width:18rem;border-radius:0.5rem;background-color:', ';'], _colors3.default.gray[1]);
	var Form = /*#__PURE__*/_styledComponents2.default.div.withConfig({
	  displayName: 'signin__Form'
	})(['display:flex;align-items:center;padding-bottom:1.5rem;margin-bottom:1.5rem;box-shadow:0 .1875rem 0 #e6ebf1;']);
	var Label = /*#__PURE__*/_styledComponents2.default.label.withConfig({
	  displayName: 'signin__Label'
	})(['color:#6b7c93;font-weight:300;letter-spacing:0.025em;']);
	var Input = /*#__PURE__*/_styledComponents2.default.input.withConfig({
	  displayName: 'signin__Input'
	})(['color:\'#424770\';font-size:1rem;line-height:2rem;letter-spacing:\'0.025em\';::placeholder{color:#aab7c4;}display:block;min-width:16rem;max-width:30rem;padding:0.5rem 1rem;box-shadow:rgba(50,50,93,0.14902) 0 .0625rem .1875rem,rgba(0,0,0,0.0196078) 0 .0625rem 0;border-radius:0.25rem;background:', ';transition:all 150ms ease;&:hover{box-shadow:rgba(50,50,93,0.109804) 0 .125rem .0625rem,rgba(0,0,0,0.0784314) 0 0 .0625rem;}&:focus{box-shadow:rgba(50,50,93,0.109804) 0 .25rem .375rem,rgba(0,0,0,0.0784314) 0 .0625rem .1875rem;}'], _colors3.default.white);
	
	var Button = /*#__PURE__*/_styledComponents2.default.button.withConfig({
	  displayName: 'signin__Button'
	})(['white-space:nowrap;border:0;outline:0;display:inline-block;font-size:1.5rem;line-height:2rem;min-width:10rem;max-width:30rem;padding:0.5rem 1rem;color:#fff;border-radius:.25rem;font-size:.9375rem;font-weight:600;letter-spacing:0.025em;text-decoration:none;transition:all 150ms ease;background-color:', ';box-shadow:0 .25rem .375rem rgba(50,50,93,0.11),0 .0625rem .1875rem rgba(0,0,0,0.08);&:hover{color:#fff;cursor:pointer;background-color:', ';transform:translateY(-.0625rem);box-shadow:0 .4375rem .875rem rgba(50,50,93,0.1),0 .1875rem .375rem rgba(0,0,0,0.08);}&:active{color:#fff;cursor:pointer;background-color:', ';transform:translateY(.0625rem);box-shadow:0 .1875rem .3125rem rgba(50,50,93,0.1),0 0 .0625rem rgba(0,0,0,0.08);}', ';'], _colors3.default.indigo[6], _colors3.default.indigo[5], _colors3.default.indigo[8], (0, _mapProps2.default)({
	  color: function color(_color) {
	    var lighter = (0, _polished.lighten)(0.05, _color);
	    var darker = (0, _polished.darken)(0, _color);
	    return (0, _styledComponents.css)(['color:', ';background-color:', ';&:hover{background-color:', ';}&:active{background-color:', ';}'], _color, _colors3.default.white, lighter, darker);
	  }
	}));
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-signin-js-082432ecca94b46c23cd.js